import React from 'react';
import { IconSvgProps } from '@models/common';

const Copy: React.FC<IconSvgProps> = (props) => {
  const { size = 20, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.5343 11.6672C12.281 11.6672 12.6544 11.6672 12.9396 11.5218C13.1905 11.394 13.3945 11.19 13.5223 10.9391C13.6676 10.6539 13.6676 10.2806 13.6676 9.53382V4.13382C13.6676 3.38709 13.6676 3.01372 13.5223 2.7285C13.3945 2.47762 13.1905 2.27364 12.9396 2.14581C12.6544 2.00049 12.281 2.00049 11.5343 2.00049H7.80098C7.05424 2.00049 6.68087 2.00049 6.39566 2.14581C6.14477 2.27364 5.9408 2.47762 5.81297 2.7285C5.66764 3.01372 5.66764 3.38708 5.66764 4.13382M5.13431 14.3338H8.86764C9.61438 14.3338 9.98775 14.3338 10.273 14.1885C10.5238 14.0607 10.7278 13.8567 10.8557 13.6058C11.001 13.3206 11.001 12.9472 11.001 12.2005V6.80049C11.001 6.05375 11.001 5.68038 10.8557 5.39517C10.7278 5.14429 10.5238 4.94031 10.273 4.81248C9.98775 4.66716 9.61438 4.66716 8.86764 4.66716H5.13431C4.38757 4.66716 4.0142 4.66716 3.72899 4.81248C3.47811 4.94031 3.27413 5.14429 3.1463 5.39517C3.00098 5.68038 3.00098 6.05375 3.00098 6.80049V12.2005C3.00098 12.9472 3.00098 13.3206 3.1463 13.6058C3.27413 13.8567 3.47811 14.0607 3.72899 14.1885C4.0142 14.3338 4.38757 14.3338 5.13431 14.3338Z'
        stroke='currentColor'
        strokeWidth='1.2'
      />
    </svg>
  );
};

export default Copy;
